import { render, staticRenderFns } from "./SchoolHome.vue?vue&type=template&id=11f845ca&scoped=true"
import script from "./SchoolHome.vue?vue&type=script&lang=js"
export * from "./SchoolHome.vue?vue&type=script&lang=js"
import style0 from "./SchoolHome.vue?vue&type=style&index=0&id=11f845ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f845ca",
  null
  
)

export default component.exports